<template>
  <div>
    <div>
      <div style="text-align: right;">
        <textarea v-model="newComment" rows="20" class="font-primary pre-wrap full-width full-height comment-text"></textarea>
        <button @click="$emit('saveComment', outfit, newComment)">Add</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'OutfitCommentModal',
  props: {
    comments: {
      type: String,
      default: ''
    },
    outfit: {
      type: Number,
      required: false
    }
  },

  data () {
    return {
      newComment: this.comments
    }
  }
}
</script>

<style lang="less" scoped>
.pre-wrap {
  white-space: pre-wrap;
}
.comment-text {
  font-family: 'Montserrat';
  font-size: 20px;
  height: 300px;
}
</style>
